<template>
  <div class="v-legend"
       :style="[styles]"
  >
    <slot/>
  </div>
</template>

<script>

import VMeasurable from "../../mixins/measurable";

export default {
  name: 'VLegend',
  mixins: [VMeasurable],
  computed: {
    styles() {
      return {
        ...this.measurableStyles,
      }
    },
  }
};
</script>

<style lang="scss">
@import "VLegend";
</style>
